import {
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ReflectiveInjector,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
// import {VariantHistoryComponent} from './variant-history.component';
// import {ProductExcelComponent} from './evs/product/product.excel.component';
// import {StoreExcelComponent} from './evs/store/store.excel.component';

declare var $: any;

@Component({
    selector: 'dynamic-component',
    // Reference to the components must be here in order to dynamically create them
    entryComponents: [
        // VariantHistoryComponent, ProductExcelComponent, StoreExcelComponent
    ],
    templateUrl: 'dialog.template.html'
})
export class DialogComponent implements OnInit {
    currentComponent = null;
    title: string = null;
    size: string = null;
    index: string = '';

    @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer: ViewContainerRef;

    // component: Class for the component you want to create
    // inputs: An object with key/value pairs mapped to input name/input value
    @Input() set componentData(data: { component: any, inputs: any }) {
        if (!data) {
            return;
        }

        // Inputs need to be in the following format to be resolved properly
        let inputProviders = Object.keys(data.inputs).map((inputName) => {
            return { provide: inputName, useValue: data.inputs[inputName] };
        });
        let resolvedInputs = ReflectiveInjector.resolve(inputProviders);

        // We create an injector out of the data we want to pass down and this components injector
        let injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, this.dynamicComponentContainer.parentInjector);

        // We create a factory out of the component we want to create
        let factory = this.resolver.resolveComponentFactory(data.component);

        // We create the component using the factory and the injector
        let component = factory.create(injector);

        // We insert the component into the dom container
        this.dynamicComponentContainer.insert(component.hostView);
        if (data.inputs['title']) {
            this.title = data.inputs['title'];
        }
        if (data.inputs['index']) {
            this.index = data.inputs['index'];
            setTimeout(() => {    //<<<---    using ()=> syntax
                $('#modalDialog' + data.inputs['index']).modal('show');
            }, 300);
        } else {
            $('#modalDialog').modal('show');
        }
        if (data.inputs['size']) {
            this.size = data.inputs['size'];
        }
        // We can destroy the old component is we like by calling destroy
        if (this.currentComponent) {
            this.currentComponent.destroy();
        }

        this.currentComponent = component;
    }

    @Output() updated = new EventEmitter();

    /**
     * Close div exampleGrid
     */
    close(index?: any) {
        $('#modalDialog' + index).modal('hide');
        this.updated.emit(true);
    }

    constructor(private resolver: ComponentFactoryResolver) {

    }

    ngOnInit() {
        var updated = this.updated;
        setTimeout(() => {
            $('#modalDialog' + this.index).on('hidden.bs.modal', function () {
                updated.emit(true);
            })
        }, 300)
    }
}




// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/helper/dialog.component.ts